if(!customElements.get('predictive-search')) { 
  class PredictiveSearch extends HTMLElement {
    constructor() {
      super()

      this.input = this.querySelector('input[type="search"]')
      this.searchTypes = this.dataset.enabledTypes
      this.predictiveSearchResults = this.querySelector('#predictive-search')
      this.details = this.closest('details')
      this.summary = this.details.querySelector('summary')

      this.input.addEventListener(
        'input',
        debounce((event) => {
          this.onChange(event)
        }, 300).bind(this)
      )
      document.body.addEventListener('click', (e) => {
        if (!this.parentNode.hasAttribute('open')) {
          const node = e.target.nodeName
          if(node === 'A') {
            this.input.value = ''
            this.close()
          }
        }
      })
      this.addEventListener('submit', (e) => { 
        this.close()
      })
    }

    onChange(event) {
      const searchTerm = this.input.value.trim()
      if(!searchTerm.length) { 
        this.clear()
        return
      }
      this.getSearchResults(searchTerm)
    }

    getSearchResults(searchTerm) {
      fetch(
        `${routes.predictive_search_url}?q=${searchTerm}&resources[type]=query,${this.searchTypes}&resources[options][fields]=body,title,variants.title&section_id=predictive-search`
      )
        .then((response) => {
          if (!response.ok) {
            var error = new Error(response.status)
            this.close()
            throw error
          }
          return response.text()
        })
        .then((text) => {
          const resultsMarkup = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#shopify-section-predictive-search').innerHTML
          this.predictiveSearchResults.innerHTML = resultsMarkup
          this.open()
        })
        .catch((error) => {
          this.close()
          throw error
        })
    }
    clear() { 
      this.predictiveSearchResults.innerHTML = ''
    }
    open() {
      this.predictiveSearchResults.style.display = 'block'
      this.predictiveSearchResults.classList.add('open')
    }
    close() {
      this.predictiveSearchResults.classList.remove('open')
      if(this.details.hasAttribute('open')) { 
        this.predictiveSearchResults.innerHTML = ''
        this.predictiveSearchResults.classList.remove('open')
        this.summary.click()
      }
    }
  }

  customElements.define('predictive-search', PredictiveSearch)
  }